import React, { useState } from "react";
import { Container, Row, Col } from "react-bootstrap";
import myImg from "../../Assets/11.png";
import wechatQR from "../../Assets/weixin.png"; // 微信二维码图片
import Tilt from "react-parallax-tilt";
import { AiOutlineMail, AiOutlinePhone } from "react-icons/ai";
import { SiWechat } from "react-icons/si";

function Home2() {
  const [showTooltip, setShowTooltip] = useState(null);

  const wechatQRStyle = {
    position: "absolute",
    bottom: "100%",
    left: "50%",
    transform: "translateX(-50%) translateY(-15px)",
    width: "150px",
    padding: "5px",
    border: "1px solid #ddd",
    backgroundColor: "#fff",
    borderRadius: "8px",
    boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
    zIndex: 100,
  };

  const tooltipTextStyle = {
    position: "absolute",
    bottom: "100%",
    left: "50%",
    transform: "translateX(-50%) translateY(-15px)",
    backgroundColor: "#fff",
    padding: "8px 12px",
    borderRadius: "8px",
    border: "1px solid #ddd",
    boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
    zIndex: 100,
    whiteSpace: "nowrap",
    color: "#6610f2",
    fontWeight: 500,
    fontSize: "1.2rem",
    letterSpacing: "0.05em",
  };

  // 箭头样式
  const arrowStyle = {
    position: "absolute",
    top: "100%",
    left: "50%",
    transform: "translateX(-50%)",
    width: 0,
    height: 0,
    borderLeft: "8px solid transparent",
    borderRight: "8px solid transparent",
    borderTop: "8px solid #fff",
    filter: "drop-shadow(0 -1px 1px rgba(0,0,0,0.1))",
    zIndex: 101,
  };

  const iconStyle = {
    fontSize: "2rem",
    color: "#6610f2",
    transition: "color 0.3s",
    cursor: "pointer",
  };

  const handleMouseEnter = (e) => {
    e.currentTarget.style.color = "#4b06b9";
  };
  const handleMouseLeave = (e) => {
    e.currentTarget.style.color = "#6610f2";
  };

  return (
    <Container fluid className="home-about-section" id="about">
      <Container>
<Row>
          <Col md={8} className="home-about-description">
            <h1 style={{ fontSize: "2.6em" }}>
              自我<span className="purple">介绍</span>
            </h1>
            <p className="home-about-body">
              作为一名从<b className="purple">嵌入式软件工程师</b>转行的后期创作者，在几年的探索中，逐渐发现——无论是敲代码还是剪视频，都能带来强烈的成就感。或许是因为，它们都需要创意与逻辑的完美融合。
              <br />
              <br />
              近几年一直在尝试将自己的兴趣和技能结合起来，打造更有趣、更有深度的作品。直到的
            
                <b className="purple">AI技术</b>的兴起，让我打开了新的想象力！
              <br />
              <br />
              目前专注于<b className="purple">知识科普 / 商业财经</b>的视频创作，精于后期制作，并将 AI 工具融入日常创作流程，同时也在逐步精进视频的前期拍摄。
            
              <br />
              <br />
              当然，创作并不局限于某一领域。从<b className="purple">软件工程师</b>到<b className="purple">后期剪辑师</b>，这段旅程让我掌握了持续学习和跨界思维的能力。未来，依然愿意不断突破自己，尝试更多可能。             
            </p>
          </Col>    
          <Col md={4} className="myAvtar">
            <Tilt>
              <img src={myImg} className="img-fluid" alt="avatar" />
            </Tilt>
          </Col>
        </Row>

        <Row>
          <Col md={12} className="home-about-social">
            <h1>联系我</h1>
            <p style={{ fontSize: "1.3em", marginTop: "20px"}}>
              如果你对科普、科技、AI等领域的创作也有热情，欢迎来聊
              <br />
              说不定会碰撞出点不一样的东西~
            </p>
            <ul
              className="home-about-social-links"
              style={{ position: "relative", paddingLeft: 0 }}
            >
              {/* 微信 */}
              <li
                className="social-icons"
                style={{
                  position: "relative",
                  display: "inline-block",
                  marginRight: "8px",
                }}
                onMouseEnter={() => setShowTooltip("wechat")}
                onMouseLeave={() => setShowTooltip(null)}
              >
                <a
                  href="#wechat"
                  onClick={(e) => e.preventDefault()}
                  className="home-social-icons"
                  style={iconStyle}
                  onMouseEnter={handleMouseEnter}
                  onMouseLeave={handleMouseLeave}
                >
                  <SiWechat />
                </a>
                {showTooltip === "wechat" && (
                  <div style={{ ...wechatQRStyle, position: "absolute" }}>
                    <img
                      src={wechatQR}
                      alt="微信二维码"
                      style={{ width: "100%" }}
                    />
                    <div style={arrowStyle} />
                  </div>
                )}
              </li>

              {/* 邮箱 */}
              <li
                className="social-icons"
                style={{
                  position: "relative",
                  display: "inline-block",
                  marginRight: "8px",
                }}
                onMouseEnter={() => setShowTooltip("email")}
                onMouseLeave={() => setShowTooltip(null)}
              >
                <a
                  href="mailto:hello@wujiayi.vip"
                  className="home-social-icons"
                  style={iconStyle}
                  onMouseEnter={handleMouseEnter}
                  onMouseLeave={handleMouseLeave}
                >
                  <AiOutlineMail />
                </a>
                {showTooltip === "email" && (
                  <div style={{ ...tooltipTextStyle, position: "absolute" }}>
                    hello@wujiayi.vip
                    <div style={arrowStyle} />
                  </div>
                )}
              </li>

              {/* 电话 */}
              <li
                className="social-icons"
                style={{
                  position: "relative",
                  display: "inline-block",
                  marginRight: "8px",
                }}
                onMouseEnter={() => setShowTooltip("phone")}
                onMouseLeave={() => setShowTooltip(null)}
              >
                <a
                  href="tel:13439023158"
                  className="home-social-icons"
                  style={iconStyle}
                  onMouseEnter={handleMouseEnter}
                  onMouseLeave={handleMouseLeave}
                >
                  <AiOutlinePhone />
                </a>
                {showTooltip === "phone" && (
                  <div style={{ ...tooltipTextStyle, position: "absolute" }}>
                    134 3902 3158
                    <div style={arrowStyle} />
                  </div>
                )}
              </li>
            </ul>
          </Col>
        </Row>
      </Container>
    </Container>
  );
}

export default Home2;
